/**
 * @module modules
 * @description Core business modules: auth, users, storage, taxonomy, etc.
 *
 * @dependencies
 * - NONE (fully isolated from db/, core/, engine/, runtime/)
 *
 * @note Modules are intentionally isolated. All dependencies are injected via
 *       ModuleContext (ctx). This ensures modules are portable and testable.
 *       NEVER import from ../db/, ../core/, ../engine/, or ../runtime/.
 *       Use ctx.db, ctx.helpers, ctx.services['name'] instead.
 *
 * @note links, charts migrated to plugins (NEX-49):
 *       @gzl10/nexus-plugin-bookmarks, @gzl10/nexus-plugin-charts
 * @note tags returned to core as taxonomy module (NEX-276)
 * @note compliance migrated to plugin (NEX-78):
 *       @gzl10/nexus-plugin-compliance
 * @note webhooks migrated to plugin (NEX-50): @gzl10/nexus-plugin-webhooks
 * @note schedules returned to core module (NEX-286)
 * @note notifications migrated to plugin (NEX-51):
 *       @gzl10/nexus-plugin-notifications
 * @note remote migrated to plugin (NEX-51):
 *       @gzl10/nexus-plugin-remote
 */

import { loggerModule } from './logger/index.js'
import { mastersModule } from './masters/index.js'
import { systemModule } from './system/index.js'
import { uiSettingsModule } from './ui-settings/index.js'
import { storageModule } from './storage/index.js'
import { usersModule } from './users/index.js'
import { authModule } from './auth/index.js'
import { mailModule } from './mail/index.js'
import { observabilityModule } from './observability/index.js'
import { pluginsModule } from './plugins/index.js'
import { auditModule } from './audit/index.js'
import { taxonomyModule } from './taxonomy/index.js'
import { schedulesModule } from './schedules/index.js'

// Individual module exports
export {
  loggerModule,
  mastersModule,
  systemModule,
  pluginsModule,
  uiSettingsModule,
  storageModule,
  taxonomyModule,
  usersModule,
  auditModule,
  authModule,
  mailModule,
  observabilityModule,
  schedulesModule
}

// Re-export UI settings entities for backward compatibility
export { uiStyleGuideEntity } from './ui-settings/index.js'

/** All core modules (for engine loader) */
export const CORE_MODULES = [
  loggerModule,
  mastersModule,
  systemModule,
  pluginsModule,
  uiSettingsModule,
  storageModule,
  taxonomyModule,
  usersModule,
  auditModule,
  authModule,
  mailModule,
  observabilityModule,
  schedulesModule
]
